var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"parallax-glider",style:({ backgroundImage: 'url(' + _vm.img1 + ')' }),attrs:{"id":_vm.sectionID}},[_c('div',{staticClass:"layer",style:({ backgroundImage: 'url(' + _vm.img2 + ')' }),attrs:{"id":_vm.layerID}})])
}
var staticRenderFns = []

export { render, staticRenderFns }